import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestApi from '@infrastructure/family-fest-api';
export const fetchFamilyFestCompanyAttendeesGridAsync = createAsyncThunk('familyFest/fetchCompanyAttendeesGrid', async ({ eventId, request }, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.getFamilyFestCompanyAttendeesGrid(eventId, request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
